import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { ITripInformationState } from '../store/tripInformation.types'
import { getTripInformationSelector } from '../selectors'
import { getTripInformationOptionsSelector } from '../../options/selectors/tripInformationOptions.selector'
import { ITripInformationOptionsState } from '../../options/store/options.types'
import { setRegistrationTailNumber } from '../store/tripInformation.actions'
import { optionwWithStateIds } from '../utils/tripInformation.util'

export function* setTripInfoRegTailNumber() {
  const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
  const tripInfoOptions: ITripInformationOptionsState = yield select(getTripInformationOptionsSelector)
  const { emsRegTailNumberOptions } = tripInfoOptions
  const { __regTailNumberOption } = tripInformation
  try {
    const regTailNumberOption = optionwWithStateIds(__regTailNumberOption, emsRegTailNumberOptions)

    yield put(setRegistrationTailNumber(regTailNumberOption))
  } catch (e) {
    yield put(throwPcrException(`setTripInfoRegTailNumber() error: ${e}`))
  }
}

export function* setTripInfoRegTailNumberSaga() {
  yield takeLatest([TripInformationConstants.SET_REG_TAIL_NUMBER_OPTION], performWithMutexHOG, setTripInfoRegTailNumber)
}
